const DEFAULT_CHILDREN_AGE = 10

const createChildrenAges = (kidsCount: number): number[] => {
    return Array.from({ length: kidsCount }, () => DEFAULT_CHILDREN_AGE)
}

export default createChildrenAges
